import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import LoginReducer from './LoginReducer';
import { loginReducerKey } from './LoginConstants';
import LoginModal from './LoginModal';
import {
  init,
  openForgotPasswordDialog,
  openResetPasswordWithTokenDialog,
  submitLoginModal,
  setData,
  resetState,
  closeLoginModal,
} from './LoginActions';
import { openInstitutionModal } from './Institution/InstitutionActions';
import { openRegisterModal } from './Register/RegisterActions';
import {
  hasInstitutionLogin as hasInstitutionLoginSelector,
  hasRegistration as hasRegistrationSelector,
  ipAddress as ipAddressSelector,
  isAnonymousUser as isAnonymousUserSelector,
  isFormDisabled as isFormDisabledSelector,
  isLoading as isLoadingSelector,
  loginFail as loginFailSelector,
  notifications as notificationsSelector,
  loginBlockedTime as loginBlockedTimeSelector,
  data as dataSelector,
} from './LoginSelectors';

const mapStateToProps = (state) => ({
  isAnonymousUser: isAnonymousUserSelector(),
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  isFormDisabled: isFormDisabledSelector(state),
  hasRegistration: hasRegistrationSelector(state),
  hasInstitutionLogin: hasInstitutionLoginSelector(state),
  notifications: notificationsSelector(state),
  loginFailMessage: loginFailSelector(state),
  loginBlockedTime: loginBlockedTimeSelector(state),
  data: dataSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  cancel: () => dispatch(closeLoginModal()),
  closeModal: () => dispatch(closeLoginModal()),
  onInstitutionLogin: () => {
    dispatch(closeLoginModal());
    dispatch(openInstitutionModal());
  },
  onRegister: () => {
    dispatch(closeLoginModal());
    dispatch(openRegisterModal());
  },
  init: () => dispatch(init()),
  openForgotPasswordDialog: () => dispatch(openForgotPasswordDialog()),
  openResetPasswordWithTokenDialog: () => dispatch(openResetPasswordWithTokenDialog(ownProps.token)),
  submit: (data) => dispatch(submitLoginModal(data)),
  setData: (data) => dispatch(setData(data)),
  resetState: () => dispatch(resetState()),
});

export default compose(
  withCombinedRouteParams,
  withReducer(loginReducerKey, LoginReducer, true),
  connect(mapStateToProps, mapDispatchToProps)
)(LoginModal);
